import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { useTeamsContext } from 'pages/settings/pages/teams/context/teamsContext'
import { TeamsEmpty } from '../TeamsEmpty'
import { TeamsList } from '../TeamsList'

import styles from './styles.module.scss'

const Teams = observer(() => {
  const [initialLoading, isInitialLoading] = useState(true)
  const { init, isEmpty, loading } = useTeamsContext()

  useEffect(() => {
    init().then(() => isInitialLoading(false))
  }, [])

  if (initialLoading) return <SpinnerLoader ariaLabel={'TeamsPage'} />
  if (!initialLoading && !loading && isEmpty) return <TeamsEmpty />

  return <TeamsList />
})

export const TeamsPage = observer(() => (
  <FullPageWrapper className={styles.page}>
    <Teams />
  </FullPageWrapper>
))
